import axios from 'axios';

export const Phonepay_status_api = async (merchantTransactionId) => {
  const url = process.env.REACT_APP_PAYMENT_API;
  const transactionId = merchantTransactionId;  // Set the transaction ID to the passed parameter
  const path = "/status-check";

  try {
    const response = await axios.post(`${url}${path}`, {
      transactionId: transactionId  // Send transactionId in the request body
    });

    // Handle the response
    return response
  } catch (error) {
    // Handle any errors that occur during the request
    return null;
  }
};

export default Phonepay_status_api